import FieldError from './FieldError';
import ObjectError from './ObjectError';
import UnknownError from './UnknownError';
import { logoutDueToExpiredSession } from 'services/authUtils';
import { ROUTE_PATHS } from '../../routes/constants';
import globalErrorHandler from '../globalErrorHandler';
import { isForbiddenError, isUnauthorizedError } from '../errorUtils';

async function errorMapper(error, errorFieldMapper = {}, isRequestWithAuth = true) {
  // Check for 403 Forbidden errors first - insufficient role/permission, session stays alive
  if (isForbiddenError(error)) {
    // Notify global error handler
    globalErrorHandler.handleForbiddenError(error);
    // Still throw the error for proper handling
  }

  // Don't redirect on login page for auth errors
  const isLoginPage = window.location.pathname === ROUTE_PATHS.LOGIN;

  // 401 (or an OAuth refresh/token failure) means the token is dead - the operator is not
  // authenticated anymore, regardless of what page/role they were on. Drop the stale session
  // and send them back to login instead of leaving the app hanging on a failed request.
  if (
    !isLoginPage &&
    isRequestWithAuth &&
    (isUnauthorizedError(error) ||
      // eslint-disable-next-line max-len
      ['invalid_refresh_token', 'invalid_token', 'access_denied'].includes(error.response?.body?.error))
  ) {
    logoutDueToExpiredSession();
  }
  if (error?.response?.body?.fields) {
    const errorFields = error.response.body.fields.map(({ code, field }) => ({
      field: errorFieldMapper[field] ? errorFieldMapper[field] : field,
      code
    }));
    throw new FieldError({
      code: error.response.body.code,
      status: error.status,
      fields: errorFields
    });
  } else if (error?.response?.body?.args) {
    throw new ObjectError({
      status: error.status,
      code: error.response.body.code,
      args: error.response.body.args
    });
  } else {
    throw new UnknownError({
      status: error?.status,
      code: error?.response?.body?.code || error?.response?.body?.error,
      message: error?.response?.body?.message || error?.response?.body?.error_description || error.message,
      stack: error.stack,
      details: error?.response?.body?.details,
      errors: error?.response?.body?.errors
    });
  }
}

export default errorMapper;
